import Lottie from 'react-lottie-player'
import { useSelector } from 'react-redux'
import { path } from 'ramda'
import styled from 'styled-components'
import animationData from './loading.json'

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 9200;
`

const lottieOptions = {
  loop: true,
  play: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

const Loading: React.FC<Nothing> = () => {
  const semaphore = useSelector(path(['loading', 'semaphore']))
  if (!semaphore) return null
  return (
    <LoadingWrapper>
      <Lottie {...lottieOptions} style={{ height: 100, width: 100 }} />
    </LoadingWrapper>
  )
}

export default Loading
